import { render, staticRenderFns } from "./CopyIMPV.vue?vue&type=template&id=5288b9ef&scoped=true&lang=pug"
import script from "./CopyIMPV.vue?vue&type=script&lang=js"
export * from "./CopyIMPV.vue?vue&type=script&lang=js"
import style0 from "./CopyIMPV.vue?vue&type=style&index=0&id=5288b9ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5288b9ef",
  null
  
)

export default component.exports